import { useEffect } from "react";

// track user interaction via clarity without setting cookies
export const useClarity = (hasConsent: boolean) => {
    useEffect(() => {
        // @ts-ignore
        if (window.clarity) return;
        (function (c: any, l: any, a: any, r: any, i?: any, t?: any, y?: any) {
            c[a] =
                c[a] ||
                function () {
                    (c[a].q = c[a].q || []).push(arguments);
                };
            t = l.createElement(r);
            t.async = 1;
            t.src = "https://www.clarity.ms/tag/" + i;
            y = l.getElementsByTagName(r)[0];
            y.parentNode.insertBefore(t, y);
        })(window, document, "clarity", "script", "jkquc2mtur");
    }, []);

    // useEffect(() => {
    //     // @ts-ignore
    //     window.clarity && window.clarity("consent", hasConsent);
    // }, [hasConsent]);

    return;
};
